import { Component, signal, PLATFORM_ID, inject, effect } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'allas-principal-banner-app-movil',
  imports: [],
  template: `<section
    id="principal-banner-app-movil"
    class="text-white relative bg-cover bg-center"
    [class.pl-2]="!isMobile()"
    [class.grid]="!isMobile()"
    [class.grid-cols-12]="!isMobile()"
  >
    <!-- Vista Desktop -->
    @if (!isMobile()) {
    <section
      class="col-span-6 xl:col-span-6 flex flex-col gap-1 items-center justify-center py-32"
    >
      <!-- Titulo de Allas Repuestos App -->
      <img
        src="/images/services/aplicacion-movil/principal-banner-title.webp"
        alt="Allas Repuestos App"
      />

      <span
        class="text-xs xl:text-2xl font-semibold fs-condensed text-gray-900 text-center"
      >
        Tu tienda de Repuestos desde la Palma de tu Mano.
      </span>

      <!-- Botones de Acción -->
      <div
        class="flex gap-4 mt-6 justify-center xl:justify-start items-center xl:items-start"
      >
        <a
          href="https://play.google.com/store/apps/details?id=com.allasrepuestos.membresia_lealtad&pcampaignid=web_share"
          class="flex items-center justify-center bg-appPrimary-500 text-white hover:scale-105 transition-transform duration-150 ease-in px-3 xl:px-6 py-1 xl:py-2 rounded-md text-[8px] xl:text-lg font-bold xl:font-normal"
        >
          DESCARGAR APP
        </a>
        <a
          href="/login"
          class="items-center justify-center border border-appPrimary-500 text-appPrimary-500 hover:scale-105 transition-transform duration-150 ease-in px-6 py-2 rounded-md text-lg hidden xl:flex"
        >
          INICIAR SESIÓN
        </a>
      </div>
    </section>
    }

    <!-- Vista Mobile -->
    @if (isMobile()) {
    <div class="w-full h-[330px] relative">
      <img
        src="/images/services/aplicacion-movil/img-banner-movil-app.webp"
        alt="Allas Repuestos App"
        class="w-full h-full object-cover"
      />
      <!-- Texto sobre la imagen -->
      <div
        class="absolute bottom-2 left-0 right-0 text-center flex flex-col items-center"
      >
        <div>
          <span
            class="text-3xl font-black italic fs-condensed tracking-wide"
            style="color: #003f85;"
            >ALLAS REPUESTOS</span
          >
          <span
            class="text-3xl font-extrabold ml-2 italic fs-condensed tracking-wide"
            style="color: #de0307;"
            >APP</span
          >
        </div>
        <p class="text-xs fs-condensed text-gray-900 font-bold">
          Tu tienda de Repuestos desde la Palma de tu mano
        </p>
      </div>
    </div>
    }
  </section>`,
  styles: [
    `
      section#principal-banner-app-movil {
        background-size: cover;
        background-position: center;
      }

      @media (min-width: 1280px) {
        section#principal-banner-app-movil {
          background-image: url('/images/services/aplicacion-movil/principal-banner.webp') !important;
        }
      }
    `,
  ],
})
export class PrincipalBannerAppMovil {
  private platformId = inject(PLATFORM_ID);
  isMobile = signal(false);

  constructor() {
    // Detectar si es mobile solo en el browser
    if (isPlatformBrowser(this.platformId)) {
      this.checkIfMobile();

      // Escuchar cambios de tamaño de ventana
      window.addEventListener('resize', () => this.checkIfMobile());
    }
  }

  private checkIfMobile(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Considerar mobile si el ancho es menor a 1280px (breakpoint xl de Tailwind)
      this.isMobile.set(window.innerWidth < 1280);
    }
  }
}
